import React, { FC } from "react";

import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

import FeatherIcon from "feather-icons-react";

import Button from "../../shared/base-components/Button";

export interface ProfileTab1Props {
  toggleHistory?: () => void;
}

const ProfileTab1: FC<ProfileTab1Props> = ({ toggleHistory }) => {
  const information = [
    { key: "Yapılan Bakım  Tarihi", value: "12" },
    { key: "Alınan Ödeme", value: "9999999 TL" },
    { key: "Tamamlanan İş", value: "45" },
    { key: "Tamamamlanan Randevu", value: "33" },
    { key: "Eklenen Müşteri Sayısı", value: "55" },
  ];

  return (
    <React.Fragment>
      {/* <Card>
        <CardHeader>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5 className="card-title mb-0">İstatistik</h5>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {information.map((info) => {
            return (
              <div key={info.key} className="pb-3">
                <Row>
                  <Col>
                    <div>
                      <h5 className="font-size-15">{info.key}:</h5>
                    </div>
                  </Col>

                  <Col>
                    <div className="text-muted">
                      <p className="mb-2">{info.value}</p>
                    </div>
                  </Col>
                </Row>
              </div>
            );
          })}
        </CardBody>
      </Card> */}
    </React.Fragment>
  );
};

export default ProfileTab1;
